import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useBoholGetYear = (year, section = 'bohol') => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const getBaseCandidates = (targetSection) => {
    if (targetSection === 'siquijor') {
      return ['cisSiquijor', 'cissiquijor', 'cisSiquijior', 'cissiquijior'];
    }
    return ['cisBohol', 'cisbohol'];
  };

  // ✅ useCallback so we can safely use fetchData in dependencies
  const fetchData = useCallback(async () => {
    if (!year) return;
    setLoading(true);

    const bases = getBaseCandidates(section);
    let lastError = null;

    for (const base of bases) {
      try {
        const { data } = await axiosApi.get(`/${base}/byLabelYear/${year}`);
        setData(data);
        setError(null);
        setLoading(false);
        return;
      } catch (err) {
        lastError = err;
      }
    }

    setError(lastError?.response?.data?.error || 'Failed to fetch CIS data by label year');
    setData([]);
    setLoading(false);
  }, [year, section]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshIndex]); // ✅ now refreshIndex actually triggers re-fetch

  const refetch = () => setRefreshIndex((prev) => prev + 1);

  return { data, loading, error, refetch };
};

export default useBoholGetYear;
